import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectOffer } from '../../../selectors';
import { selectAdfoxParams } from '../../../selectors/adfox';
import { selectIsTestMode } from '../../../selectors/selectIsTestMode';
import {
  getPuidAreaTarget,
  getRailwayAndHighwaysPuids,
  getSpecialPriceTargetPuidForAdFox,
  getSpecialRentPriceTargetPuidForAdFox,
} from '../../../utils/adfox';

type TPuids = { [key: string]: string };

export function useAdfoxPuids(): TPuids {
  const offer = useSelector(selectOffer);
  const isTestMode = useSelector(selectIsTestMode);
  const adfoxRequestedParams = useSelector(selectAdfoxParams);

  return React.useMemo(() => {
    const puids: TPuids = {
      ...adfoxRequestedParams,
      puid6: getSpecialPriceTargetPuidForAdFox(offer.bargainTerms.prices.rur),
      puid33: getSpecialRentPriceTargetPuidForAdFox(offer.bargainTerms.price),
      ...getRailwayAndHighwaysPuids(offer),
      ...(isTestMode ? { puid32: 'test' } : {}),
    };

    if (offer.totalArea) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      puids['puid27'] = getPuidAreaTarget(offer.totalArea)!;
    }

    return puids;
  }, [adfoxRequestedParams, isTestMode, offer]);
}
